var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _vm.showInline
        ? _c("div", [
            _vm.postDetail
              ? _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.postDetail.content) },
                })
              : _c(
                  "div",
                  [
                    _c("b-skeleton", {
                      attrs: { width: "20%", animated: true },
                    }),
                    _c("b-skeleton", {
                      attrs: { width: "40%", animated: true },
                    }),
                    _c("b-skeleton", {
                      attrs: { width: "80%", animated: true },
                    }),
                    _c("b-skeleton", { attrs: { animated: true } }),
                  ],
                  1
                ),
          ])
        : [
            _vm.detailOpened == false
              ? _c("div", { staticClass: "content" }, [
                  _c("h3", [_vm._v(" " + _vm._s(_vm.postPreview.title) + " ")]),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.postPreview.preview) },
                  }),
                ])
              : _vm._e(),
            _c(
              "b-collapse",
              {
                attrs: { open: _vm.detailOpened, position: "is-bottom" },
                on: { open: _vm.loadPost, close: _vm.closeCollapse },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function (props) {
                      return [
                        _c(
                          "a",
                          { attrs: { "aria-expanded": props.open } },
                          [
                            _c("b-icon", {
                              attrs: {
                                icon: !props.open
                                  ? "chevron-down"
                                  : "chevron-up",
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  !props.open
                                    ? _vm.$t(
                                        "component.settings.about.show_more"
                                      )
                                    : _vm.$t(
                                        "component.settings.about.show_less"
                                      )
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _vm.postDetail
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.postDetail.content) },
                    })
                  : _c(
                      "div",
                      { staticClass: "mb-2" },
                      [
                        _c("b-skeleton", {
                          attrs: { width: "20%", animated: true },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "40%", animated: true },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "80%", animated: true },
                        }),
                        _c("b-skeleton", { attrs: { animated: true } }),
                      ],
                      1
                    ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }